'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'party-horn';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'e31b';
var svgPathData = ['M32 32a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm6.5 349.1l92.4 92.4 32.6-12.7-112.4-112.4-12.7 32.6zm35.8-92.2L223.1 437.7 255.7 425 87 256.3 74.3 288.9zM159 127L193 161c35-35 63-81.4 63-137l0-24-48 0 0 24c0 38.5-19.4 73.5-49 103zm87.1 70.2l31 36.6c13.6-11.5 23-19.5 28.3-24 5.8-4.9 13.2-7.5 20.7-7.3 42.5 1.1 78.3-31.7 80.8-74.2l1.8-30c1-16.6 15-29.4 31.6-29 19.4 .5 38.2-6.1 53-18.6l10-8.5-31-36.6-10 8.5c-5.8 4.9-13.2 7.5-20.7 7.3-42.5-1.1-78.3 31.7-80.8 74.2l-1.8 30c-1 16.6-15 29.4-31.6 29-19.4-.5-38.2 6.1-53 18.6-5.3 4.5-14.8 12.5-28.3 24zM351 319L385 353c29.5-29.5 64.6-49 103-49l24 0 0-48-24 0c-55.4 0-102.1 28.1-137 63zm97-159a32 32 0 1 0 64 0 32 32 0 1 0 -64 0zm0 288a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z', 'M0 480L32 512 130.9 473.5 38.5 381.1 0 480zM51.1 348.5l112.4 112.4 59.6-23.2-148.8-148.8-23.2 59.6zM87 256.3L255.7 425 320 400 112 192 87 256.3z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faPartyHorn = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;